import { render, staticRenderFns } from "./SetPasswordPopup.vue?vue&type=template&id=2c2f83e0&scoped=true"
import script from "./SetPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./SetPasswordPopup.vue?vue&type=script&lang=ts"
import style0 from "./SetPasswordPopup.vue?vue&type=style&index=0&id=2c2f83e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f83e0",
  null
  
)

export default component.exports